<template>
  <div class="profile-container">
    <div class="profile-content">
      <!-- Header с кнопкой настроек -->
      <div class="profile-header">
        <h1 class="profile-title">{{ $t('profile.title') }}</h1>
        <BaseButton variant="text" size="sm" class="settings-button" @click="goToSettings">
          <!-- SVG иконка шестеренки -->
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.3499 8.92293L19.9837 8.7192C19.9269 8.68756 19.8989 8.67169 19.8714 8.65524C19.5983 8.49165 19.3682 8.26564 19.2002 7.99523C19.1833 7.96802 19.1674 7.93949 19.1348 7.8831C19.1023 7.82677 19.0858 7.79823 19.0706 7.76998C18.92 7.48866 18.8385 7.17515 18.8336 6.85606C18.8331 6.82398 18.8332 6.79121 18.8343 6.72604L18.8415 6.30078C18.8529 5.62025 18.8587 5.27894 18.763 4.97262C18.6781 4.70053 18.536 4.44993 18.3462 4.23725C18.1317 3.99685 17.8347 3.82534 17.2402 3.48276L16.7464 3.1982C16.1536 2.85658 15.8571 2.68571 15.5423 2.62057C15.2639 2.56294 14.9765 2.56561 14.6991 2.62789C14.3859 2.69819 14.0931 2.87351 13.5079 3.22396L13.5045 3.22555L13.1507 3.43741C13.0948 3.47091 13.0665 3.48779 13.0384 3.50338C12.7601 3.6581 12.4495 3.74365 12.1312 3.75387C12.0992 3.7549 12.0665 3.7549 12.0013 3.7549C11.9365 3.7549 11.9024 3.7549 11.8704 3.75387C11.5515 3.74361 11.2402 3.65759 10.9615 3.50224C10.9334 3.48658 10.9056 3.46956 10.8496 3.4359L10.4935 3.22213C9.90422 2.86836 9.60915 2.69121 9.29427 2.62057C9.0157 2.55807 8.72737 2.55634 8.44791 2.61471C8.13236 2.68062 7.83577 2.85276 7.24258 3.19703L7.23994 3.1982L6.75228 3.48124L6.74688 3.48454C6.15904 3.82572 5.86441 3.99672 5.6517 4.23614C5.46294 4.4486 5.32185 4.69881 5.2374 4.97018C5.14194 5.27691 5.14703 5.61896 5.15853 6.3027L5.16568 6.72736C5.16676 6.79166 5.16864 6.82362 5.16817 6.85525C5.16343 7.17499 5.08086 7.48914 4.92974 7.77096C4.9148 7.79883 4.8987 7.8267 4.86654 7.88237C4.83436 7.93809 4.81877 7.96579 4.80209 7.99268C4.63336 8.26452 4.40214 8.49186 4.12733 8.65572C4.10015 8.67193 4.0715 8.68752 4.01521 8.71871L3.65365 8.91908C3.05208 9.25245 2.75137 9.41928 2.53256 9.65669C2.33898 9.86672 2.19275 10.1158 2.10349 10.3872C2.00259 10.6939 2.00267 11.0378 2.00424 11.7255L2.00551 12.2877C2.00706 12.9708 2.00919 13.3122 2.11032 13.6168C2.19979 13.8863 2.34495 14.134 2.53744 14.3427C2.75502 14.5787 3.05274 14.7445 3.64974 15.0766L4.00808 15.276C4.06907 15.3099 4.09976 15.3266 4.12917 15.3444C4.40148 15.5083 4.63089 15.735 4.79818 16.0053C4.81625 16.0345 4.8336 16.0648 4.8683 16.1255C4.90256 16.1853 4.92009 16.2152 4.93594 16.2452C5.08261 16.5229 5.16114 16.8315 5.16649 17.1455C5.16707 17.1794 5.16658 17.2137 5.16541 17.2827L5.15853 17.6902C5.14695 18.3763 5.1419 18.7197 5.23792 19.0273C5.32287 19.2994 5.46484 19.55 5.65463 19.7627C5.86915 20.0031 6.16655 20.1745 6.76107 20.5171L7.25478 20.8015C7.84763 21.1432 8.14395 21.3138 8.45869 21.379C8.73714 21.4366 9.02464 21.4344 9.30209 21.3721C9.61567 21.3017 9.90948 21.1258 10.4964 20.7743L10.8502 20.5625C10.9062 20.5289 10.9346 20.5121 10.9626 20.4965C11.2409 20.3418 11.5512 20.2558 11.8695 20.2456C11.9015 20.2446 11.9342 20.2446 11.9994 20.2446C12.0648 20.2446 12.0974 20.2446 12.1295 20.2456C12.4484 20.2559 12.7607 20.3422 13.0394 20.4975C13.0639 20.5112 13.0885 20.526 13.1316 20.5519L13.5078 20.7777C14.0971 21.1315 14.3916 21.3081 14.7065 21.3788C14.985 21.4413 15.2736 21.4438 15.5531 21.3855C15.8685 21.3196 16.1657 21.1471 16.7586 20.803L17.2536 20.5157C17.8418 20.1743 18.1367 20.0031 18.3495 19.7636C18.5383 19.5512 18.6796 19.3011 18.764 19.0297C18.8588 18.7252 18.8531 18.3858 18.8417 17.7119L18.8343 17.2724C18.8332 17.2081 18.8331 17.1761 18.8336 17.1445C18.8383 16.8247 18.9195 16.5104 19.0706 16.2286C19.0856 16.2007 19.1018 16.1726 19.1338 16.1171C19.166 16.0615 19.1827 16.0337 19.1994 16.0068C19.3681 15.7349 19.5995 15.5074 19.8744 15.3435C19.9012 15.3275 19.9289 15.3122 19.9838 15.2818L19.9857 15.2809L20.3472 15.0805C20.9488 14.7472 21.2501 14.5801 21.4689 14.3427C21.6625 14.1327 21.8085 13.8839 21.8978 13.6126C21.9981 13.3077 21.9973 12.9658 21.9958 12.2861L21.9945 11.7119C21.9929 11.0287 21.9921 10.6874 21.891 10.3828C21.8015 10.1133 21.6555 9.86561 21.463 9.65685C21.2457 9.42111 20.9475 9.25526 20.3517 8.92378L20.3499 8.92293Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.00037 12C8.00037 14.2091 9.79123 16 12.0003 16C14.2095 16 16.0003 14.2091 16.0003 12C16.0003 9.79081 14.2095 7.99995 12.0003 7.99995C9.79123 7.99995 8.00037 9.79081 8.00037 12Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

        </BaseButton>
      </div>

      <!-- Профиль пользователя -->
      <BaseCard class="profile-card">
        <div class="profile-info">
          <div class="profile-avatar-container">
            <img
              v-if="userData.photoUrl"
              :src="userData.photoUrl"
              :alt="userData.firstName"
              class="profile-avatar"
            />
            <div v-else class="profile-avatar-placeholder">
              {{ userInitials }}
            </div>
          </div>
          <div class="profile-details">
            <h2 class="profile-name">{{ fullName }}</h2>
            <div class="profile-level">
              <button 
                class="level-badge-button" 
                :class="`level-badge-${currentLevel.name.toLowerCase()}`"
                @click="goToLevels"
              >
                <span class="level-badge-title">{{ currentLevel.name }}</span>
              </button>
            </div>
          </div>
        </div>
      </BaseCard>

      <!-- Balance секция -->
      <BaseCard class="balance-card">
        <div class="balance-header">
          <span class="balance-label">{{ $t('profile.balance') }}</span>
          <div class="balance-actions">
            <button 
              class="balance-button"
              @click="openBalanceDetailsModal"
              :disabled="!balance || balance === 0"
            >
              <div class="balance-amount">
                <span class="balance-value">{{ formatBalance(balance) }} USDT</span>
                <svg 
                  v-if="balance && balance > 0"
                  class="balance-arrow"
                  width="16" 
                  height="16" 
                  viewBox="0 0 16 16" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 12L10 8L6 4"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </button>

            <div class="balance-cta-row">
              <BaseButton variant="outline" size="sm" class="deposit-button" @click="handleDepositClick">{{ $t('deposit.title') }}</BaseButton>
              <BaseButton variant="outline" size="sm" class="withdraw-button" @click="handleWithdrawClick">{{ $t('profile.withdraw') }}</BaseButton>
            </div>
          </div>
        </div>
        <p class="balance-message">{{ $t('profile.totalBalance') }}</p>
        <BaseButton 
          variant="text" 
          size="sm" 
          class="history-button"
          @click="openHistoryModal"
        >
          {{ $t('profile.viewHistory') }}
        </BaseButton>
      </BaseCard>

      <!-- Referrals секция -->
      <BaseCard class="referrals-card">
        <div class="referrals-header">
          <div class="referrals-item">
            <span class="referrals-label">{{ $t('profile.referrals') }}</span>
            <span class="referrals-value">{{ $t('profile.referralsCount', { count: 0 }) }}</span>
          </div>
          <div class="referrals-item">
            <span class="referrals-label">{{ $t('profile.rewards') }}</span>
            <div class="referrals-value">
              <span>{{ $t('profile.rewardsCount', { count: 0 }) }}</span>
            </div>
          </div>
        </div>
        <p class="referrals-message">{{ $t('profile.rewardsMessage') }}</p>
        <div class="referral-code-row">
          <div class="referral-code-text">
            <span class="referral-code-label">{{ $t('profile.yourCode') }} </span>
            <span class="referral-code-value">{{ referralCode }}</span>
          </div>
          <BaseButton
            variant="outline"
            size="sm"
            class="copy-code-button"
            :class="{ 'copied': isCopied }"
            @click="copyReferralCode"
            aria-label="Copy referral code"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.33331 1.33331H12C12.7363 1.33331 13.3333 1.93035 13.3333 2.66665V9.33331"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4 4H10.6667C11.403 4 12 4.59704 12 5.33333V12C12 12.7363 11.403 13.3333 10.6667 13.3333H4C3.26371 13.3333 2.66667 12.7363 2.66667 12V5.33333C2.66667 4.59704 3.26371 4 4 4Z"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            {{ isCopied ? $t('profile.copied') : $t('profile.copy') }}
          </BaseButton>
        </div>
      </BaseCard>

      <!-- Trader Info секция -->
      <BaseCard v-if="traderData" class="trader-card" :class="{ 'inactive': isCopyDisabled }">
        <div class="trader-header">
          <div class="trader-avatar-container">
            <img
              v-if="traderData.avatar"
              :src="traderData.avatar"
              :alt="traderData.name"
              class="trader-avatar"
            />
            <div v-else class="trader-avatar-placeholder">
              {{ traderInitials }}
            </div>
          </div>
          <div class="trader-name-container">
            <div class="trader-name">{{ traderData.name }}</div>
            <span class="trader-badge trader-badge-vip">VIP</span>
          </div>
        </div>

        <!-- Stats List -->
        <div v-if="!isCopyDisabled" class="trader-stats-list">
          <div class="trader-stat-row">
            <span class="trader-stat-label">{{ $t('profile.pnl7d') }}</span>
            <span class="trader-stat-value positive">+ {{ formatTraderStat(traderStats.pnl7d) }} USD</span>
          </div>
          <div class="trader-stat-row">
            <span class="trader-stat-label">{{ $t('profile.pnl30d') }}</span>
            <span class="trader-stat-value positive">+ {{ formatTraderStat(traderStats.pnl30d) }} USD</span>
          </div>
          <div class="trader-stat-row">
            <span class="trader-stat-label">{{ $t('profile.pnl90d') }}</span>
            <span class="trader-stat-value positive">+ {{ formatTraderStat(traderStats.pnl90d) }} USD</span>
          </div>
          <div class="trader-stat-row">
            <span class="trader-stat-label">{{ $t('profile.aum') }}</span>
            <span class="trader-stat-value neutral">{{ formatTraderStat(traderStats.aum) }} USD</span>
          </div>
          <div class="trader-stat-row">
            <span class="trader-stat-label">{{ $t('profile.roi') }}</span>
            <span class="trader-stat-value positive">+ {{ formatTraderROI(traderStats.roi) }}%</span>
          </div>
          <div class="trader-stat-row last">
            <span class="trader-stat-label">{{ $t('profile.roi90d') }}</span>
            <span class="trader-stat-value positive">+ {{ formatTraderROI(traderStats.roi90d) }}%</span>
          </div>
        </div>

        <!-- Inactive State Message -->
        <div v-if="isCopyDisabled" class="trader-inactive-message">
          <p>{{ $t('profile.inactiveTitle') }}</p>
          <p>{{ $t('profile.inactiveMessage') }}</p>
        </div>

        <!-- Action Button -->
        <div class="trader-action">
          <BaseButton
            v-if="!isCopyDisabled"
            variant="outline"
            size="md"
            full-width
            class="trader-unsubscribe-button"
            @click="showUnsubscribeModal"
          >
            {{ $t('profile.unsubscribe') }}
          </BaseButton>
          <BaseButton
            v-else
            variant="primary"
            size="md"
            full-width
            class="trader-resume-button"
            @click="handleResumeCopy"
            :disabled="isResuming"
          >
            {{ isResuming ? $t('profile.resuming') : $t('profile.resume') }}
          </BaseButton>
        </div>
      </BaseCard>

      <!-- Invite Friends кнопка -->
      <BaseButton 
        variant="primary" 
        size="lg" 
        full-width 
        class="invite-button"
        @click="handleInviteClick"
      >
        {{ $t('profile.inviteButton') }}
      </BaseButton>
    </div>
    <BottomMenu />

    <!-- Deposit Notification -->
    <DepositNotification 
      :show="showDepositNotification" 
      :amount="depositNotificationAmount" 
      @close="closeDepositNotification" 
    />

    <!-- Referral Limit Modal -->
    <transition name="level-modal-fade">
      <div
        v-if="isReferralLimitModalOpen"
        class="level-modal-overlay"
        @click.self="closeReferralLimitModal"
      >
        <div class="level-modal-card">
          <div class="referral-limit-modal-content">
            <p class="referral-limit-message">
              {{ $t('profile.referralLimitMessage') }}
            </p>
            <BaseButton 
              variant="primary" 
              size="lg" 
              full-width 
              @click="closeReferralLimitModal"
            >
              {{ $t('profile.ok') }}
            </BaseButton>
          </div>
        </div>
      </div>
    </transition>


    <!-- Unsubscribe Confirmation Modal -->
    <transition name="modal-fade">
      <div
        v-if="showUnsubscribeConfirm"
        class="modal-overlay"
        @click.self="closeUnsubscribeModal"
      >
        <BaseCard class="modal-card">
          <div class="modal-content">
            <p class="modal-message">
              {{ $t('profile.unsubscribeConfirm') }}
            </p>
            <div class="modal-actions">
              <BaseButton
                variant="outline"
                size="md"
                class="modal-button"
                @click="closeUnsubscribeModal"
              >
                {{ $t('profile.no') }}
              </BaseButton>
              <BaseButton
                variant="primary"
                size="md"
                class="modal-button"
                @click="handleStopCopy"
                :disabled="isStopping"
              >
                {{ isStopping ? $t('profile.processing') : $t('profile.yes') }}
              </BaseButton>
            </div>
          </div>
        </BaseCard>
      </div>
    </transition>

    <!-- Withdraw Modal - Step 1: Enter Details -->
    <transition name="modal-fade">
      <div
        v-if="showWithdrawModal"
        class="modal-overlay"
        @click.self="closeWithdrawModal"
      >
        <BaseCard class="modal-card withdraw-modal">
          <div class="modal-header">
            <h2 class="modal-title">{{ $t('profile.withdrawFunds') }}</h2>
            <button class="modal-close" @click="closeWithdrawModal">×</button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label class="form-label">{{ $t('profile.network') }}</label>
              <select v-model="withdrawData.network" class="form-input" required>
                <option value="">{{ $t('profile.selectNetwork') }}</option>
                <option value="TRC20">TRC20 (Tron)</option>
                <option value="ERC20">ERC20 (Ethereum)</option>
                <option value="BEP20">BEP20 (BSC)</option>
                <option value="SOL">SOL (Solana)</option>
                <option value="TON">TON (TON)</option>
                <option value="POL">POL (Polygon)</option>
                <option value="APT">APT (Aptos)</option>
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">{{ $t('profile.walletAddress') }}</label>
              <input
                v-model="withdrawData.wallet"
                type="text"
                class="form-input"
                :placeholder="$t('profile.enterWallet')"
                required
              />
            </div>
            <div class="form-group">
              <label class="form-label">{{ $t('profile.amount') }}</label>
              <input
                v-model.number="withdrawData.amount"
                type="number"
                step="0.01"
                min="15"
                class="form-input"
                :max="Math.min(balance, 1000000)"
                :placeholder="$t('profile.enterAmount')"
                required
              />
              <p class="form-hint">{{ $t('profile.available') }} {{ formatBalance(balance) }} USDT</p>
              <p class="form-hint">{{ $t('profile.minMax', { min: 15, max: 1000000 }) }}</p>
              <p v-if="withdrawAmountError" class="form-error">{{ withdrawAmountError }}</p>
            </div>
            <div class="modal-actions">
              <BaseButton variant="outline" @click="closeWithdrawModal">{{ $t('profile.cancel') }}</BaseButton>
              <BaseButton 
                @click="proceedToConfirm" 
                :disabled="!isWithdrawFormValid || isProcessing"
              >
                {{ $t('profile.continue') }}
              </BaseButton>
            </div>
          </div>
        </BaseCard>
      </div>
    </transition>

    <!-- Withdraw Confirmation Modal - Step 2: Confirm Details -->
    <transition name="modal-fade">
      <div
        v-if="showWithdrawConfirm"
        class="modal-overlay"
        @click.self="closeWithdrawConfirm"
      >
        <BaseCard class="modal-card withdraw-modal">
          <div class="modal-header">
            <h2 class="modal-title">{{ $t('profile.confirmWithdrawal') }}</h2>
            <button class="modal-close" @click="closeWithdrawConfirm">×</button>
          </div>
          <div class="modal-body">
            <div class="confirm-details">
              <div class="confirm-row">
                <span class="confirm-label">{{ $t('profile.networkLabel') }}</span>
                <span class="confirm-value">{{ withdrawData.network }}</span>
              </div>
              <div class="confirm-row">
                <span class="confirm-label">{{ $t('profile.walletAddress') }}:</span>
                <span class="confirm-value wallet-address">{{ formatWalletAddress(withdrawData.wallet) }}</span>
              </div>
              <div class="confirm-row">
                <span class="confirm-label">{{ $t('profile.amount') }}:</span>
                <span class="confirm-value">{{ formatBalance(withdrawData.amount) }} USDT</span>
              </div>
            </div>
            <div class="modal-actions">
              <BaseButton variant="outline" @click="closeWithdrawConfirm">{{ $t('profile.back') }}</BaseButton>
              <BaseButton 
                @click="proceedToPin" 
                :disabled="isProcessing"
              >
                {{ $t('profile.confirm') }}
              </BaseButton>
            </div>
          </div>
        </BaseCard>
      </div>
    </transition>

    <!-- Withdraw PIN Modal - Step 3: Enter PIN -->
    <transition name="modal-fade">
      <div
        v-if="showWithdrawPin"
        class="modal-overlay"
        @click.self="closeWithdrawPin"
      >
        <BaseCard class="modal-card withdraw-modal">
          <div class="modal-header">
            <h2 class="modal-title">{{ $t('profile.enterPin') }}</h2>
            <button class="modal-close" @click="closeWithdrawPin">×</button>
          </div>
          <div class="modal-body">
            <div class="pin-section">
              <p class="pin-description">{{ $t('profile.pinDescription') }}</p>
              <PinInput
                v-model="withdrawPin"
                :length="4"
                @complete="handlePinComplete"
              />
              <div v-if="withdrawPinError" class="error-message">
                {{ withdrawPinError }}
              </div>
            </div>
            <div class="modal-actions">
              <BaseButton variant="outline" @click="closeWithdrawPin" :disabled="isProcessing">
                {{ $t('profile.cancel') }}
              </BaseButton>
            </div>
          </div>
        </BaseCard>
      </div>
    </transition>

    <!-- Withdraw Success Modal -->
    <transition name="modal-fade">
      <div
        v-if="showWithdrawSuccess"
        class="modal-overlay"
        @click.self="closeWithdrawSuccess"
      >
        <BaseCard class="modal-card withdraw-modal">
          <div class="modal-body">
            <div class="success-screen">
              <div class="success-icon">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="32" cy="32" r="32" fill="#22c55e" opacity="0.1"/>
                  <path d="M32 8C18.745 8 8 18.745 8 32C8 45.255 18.745 56 32 56C45.255 56 56 45.255 56 32C56 18.745 45.255 8 32 8ZM28 42L18 32L20.82 29.18L28 36.34L43.18 21.18L46 24L28 42Z" fill="#22c55e"/>
                </svg>
              </div>
              <h2 class="success-title">{{ $t('profile.withdrawalSubmitted') }}</h2>
              <p class="success-message">{{ $t('profile.withdrawalMessage') }}</p>
              <BaseButton variant="primary" size="md" full-width @click="goToHistoryFromSuccess">
                {{ $t('profile.continue') }}
              </BaseButton>
            </div>
          </div>
        </BaseCard>
      </div>
    </transition>

    <!-- Transaction History Modal/Screen -->
    <transition name="modal-fade">
      <div
        v-if="showHistoryModal"
        class="modal-overlay history-overlay"
        :class="{ 'history-fullscreen': !isDesktop }"
        @click.self="closeHistoryModal"
      >
        <BaseCard class="modal-card history-modal" :class="{ 'history-fullscreen': !isDesktop }">
          <div class="modal-header">
            <h2 class="modal-title">{{ $t('profile.transactionHistory') }}</h2>
            <button class="modal-close" @click="closeHistoryModal">×</button>
          </div>
          <div class="modal-body">
            <div v-if="isLoadingHistory" class="loading-state">
              <p>{{ $t('profile.loadingHistory') }}</p>
            </div>
            <div v-else-if="historyError" class="error-state">
              <p>{{ historyError }}</p>
            </div>
            <div v-else-if="transactionHistory.length === 0" class="empty-state">
              <p>{{ $t('profile.noTransactions') }}</p>
            </div>
            <div v-else class="history-list">
              <div
                v-for="transaction in transactionHistory"
                :key="transaction.id"
                class="history-item"
              >
                <div class="history-item-header">
                  <span class="history-type" :class="transaction.type">
                    {{ transaction.type === 'deposit' ? $t('profile.deposit') : $t('profile.withdrawal') }}
                  </span>
                  <span class="history-amount" :class="transaction.type">
                    {{ transaction.type === 'deposit' ? '+' : '-' }}{{ formatBalance(transaction.amount) }} USDT
                  </span>
                </div>
                <div class="history-item-details">
                  <span class="history-date">{{ formatTransactionDate(transaction.date) }}</span>
                  <span class="history-status" :class="transaction.status">
                    {{ $t(`profile.${transaction.status}`) }}
                  </span>
                </div>
                <div v-if="transaction.network" class="history-item-meta">
                  <span>{{ $t('profile.networkLabel') }} {{ transaction.network }}</span>
                </div>
                <div v-if="transaction.wallet_address" class="history-item-meta">
                  <span>{{ $t('profile.addressLabel') }} {{ transaction.wallet_address }}</span>
                </div>
                <div v-else-if="transaction.type === 'withdrawal'" class="history-item-meta">
                  <span>{{ $t('profile.addressLabel') }} {{ $t('profile.na') }}</span>
                </div>
                <div v-if="transaction.status === 'declined'" class="history-item-meta">
                  <span>{{ $t('profile.reasonLabel') }} {{ transaction.reason || $t('profile.noReason') }}</span>
                </div>
              </div>
            </div>
          </div>
        </BaseCard>
      </div>
    </transition>

  </div>
</template>

<script>
import { computed, ref, onMounted, onUnmounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import BaseCard from '../components/ui/BaseCard.vue'
import BaseButton from '../components/ui/BaseButton.vue'
import PinInput from '../components/ui/PinInput.vue'
import { useTelegramData } from '../composables/useTelegram.js'
import BottomMenu from '../components/ui/BottomMenu.vue'
import DepositNotification from '../components/ui/DepositNotification.vue'
import { startDepositHeartbeat, stopDepositHeartbeat } from '../services/depositHeartbeat.js'
import { apiService } from '../services/api.js'
import { useProfileData } from '../composables/useProfileData.js'
import { BASE_TRADER_STATS, TRADER_STATS_STORAGE_KEY } from '../config/traderConfig.js'
import { resetScroll } from '../utils/scrollUtils.js'

export default {
  name: 'ProfileScreen',
  components: {
    BaseCard,
    BaseButton,
    BottomMenu,
    PinInput,
    DepositNotification
  },
  setup() {
    const router = useRouter()
    const { t } = useI18n()
    const { userData } = useTelegramData()
    const { profileData, loadProfileData } = useProfileData()
    // Deposit notification state
    const showDepositNotification = ref(false)
    const depositNotificationAmount = ref(0)

    const closeDepositNotification = () => {
      showDepositNotification.value = false
      depositNotificationAmount.value = 0
    }

    const isReferralLimitModalOpen = ref(false)
    const referralCode = ref('HSV4S1J')
    const isCopied = ref(false)
    const traderData = ref(null)
    const isCopyDisabled = ref(profileData.value.copy === false)
    const showUnsubscribeConfirm = ref(false)
    const isStopping = ref(false)
    const isResuming = ref(false)
    
    // Базовые значения для метрик трейдера (из единого конфига)
    const baseTraderStats = { ...BASE_TRADER_STATS }
    
    // Загружаем сохраненные значения из localStorage или используем базовые
    const loadSavedTraderStats = () => {
      try {
        const saved = localStorage.getItem(TRADER_STATS_STORAGE_KEY)
        if (saved) {
          const parsed = JSON.parse(saved)
          // Проверяем, что значения в допустимых пределах (±3.5%)
          const isValid = (value, base) => {
            const variation = Math.abs((value - base) / base)
            return variation <= 0.035 && !isNaN(value) && isFinite(value)
          }
          
          if (
            isValid(parsed.pnl7d, baseTraderStats.pnl7d) &&
            isValid(parsed.pnl30d, baseTraderStats.pnl30d) &&
            isValid(parsed.pnl90d, baseTraderStats.pnl90d) &&
            isValid(parsed.aum, baseTraderStats.aum) &&
            isValid(parsed.roi, baseTraderStats.roi) &&
            isValid(parsed.roi90d, baseTraderStats.roi90d)
          ) {
            return parsed
          }
        }
      } catch (error) {
        console.error('Error loading saved trader stats:', error)
      }
      return null
    }
    
    // Сохраняем текущие значения в localStorage
    const saveTraderStats = () => {
      try {
        localStorage.setItem(TRADER_STATS_STORAGE_KEY, JSON.stringify(traderStats.value))
      } catch (error) {
        console.error('Error saving trader stats:', error)
      }
    }
    
    // Текущие отображаемые значения (будут периодически изменяться)
    const savedStats = loadSavedTraderStats()
    const traderStats = ref(savedStats || {
      pnl7d: baseTraderStats.pnl7d,
      pnl30d: baseTraderStats.pnl30d,
      pnl90d: baseTraderStats.pnl90d,
      aum: baseTraderStats.aum,
      roi: baseTraderStats.roi,
      roi90d: baseTraderStats.roi90d
    })
    
    // Интервал для периодического обновления значений
    let statsUpdateInterval = null
    
    // Withdraw modals
    const showWithdrawModal = ref(false)
    const showWithdrawConfirm = ref(false)
    const showWithdrawPin = ref(false)
    const showWithdrawSuccess = ref(false)
    const isProcessing = ref(false)
    const withdrawData = ref({
      network: '',
      wallet: '',
      amount: null
    })
    const withdrawPin = ref('')
    const withdrawPinError = ref('')
    const withdrawAmountError = ref('')
    
    // History modal
    const showHistoryModal = ref(false)
    const isLoadingHistory = ref(false)
    const historyError = ref(null)
    const transactionHistory = ref([])
    const isDesktop = computed(() => window.innerWidth >= 924)
    
    // Используем данные из composable
    const balance = computed(() => profileData.value.balance ?? 0)
    const exp = computed(() => profileData.value.exp ?? 0)
    
    // Определение уровней на основе exp
    const getLevelByExp = (expValue) => {
      const expNum = Number(expValue) || 0
      
      if (expNum >= 0 && expNum < 100) {
        return {
          name: 'Bronze',
          minExp: 0,
          maxExp: 100,
          nextLevel: 'Silver'
        }
      } else if (expNum >= 100 && expNum < 250) {
        return {
          name: 'Silver',
          minExp: 100,
          maxExp: 250,
          nextLevel: 'Gold'
        }
      } else if (expNum >= 250 && expNum < 625) {
        return {
          name: 'Gold',
          minExp: 250,
          maxExp: 625,
          nextLevel: 'Platinum'
        }
      } else if (expNum >= 625 && expNum < 1000) {
        return {
          name: 'Platinum',
          minExp: 625,
          maxExp: 1000,
          nextLevel: 'VIP'
        }
      } else {
        return {
          name: 'VIP',
          minExp: 1000,
          maxExp: 1000,
          nextLevel: null
        }
      }
    }
    
    // Вычисление прогресса в текущем уровне
    const calculateLevelProgress = (expValue, level) => {
      if (!level) return 0
      
      const expNum = Number(expValue) || 0
      const levelRange = level.maxExp - level.minExp
      const expInLevel = expNum - level.minExp
      
      if (levelRange === 0) return 100 // Если это последний уровень
      
      return Math.min(100, Math.max(0, (expInLevel / levelRange) * 100))
    }
    
    // Вычисление оставшегося опыта до следующего уровня
    const getExpToNextLevel = (expValue, level) => {
      if (!level || !level.nextLevel) return 0
      
      const expNum = Number(expValue) || 0
      const expNeeded = level.maxExp - expNum
      
      return Math.max(0, expNeeded)
    }
    
    const currentLevel = computed(() => {
      const level = getLevelByExp(exp.value)
      const progress = calculateLevelProgress(exp.value, level)
      const expToNext = getExpToNextLevel(exp.value, level)
      
      return {
        name: level.name,
      badge: null,
        progress: progress,
        startLabel: level.name,
        nextLabel: level.nextLevel || level.name,
        minExp: level.minExp,
        maxExp: level.maxExp,
        currentExp: exp.value,
        expToNext: expToNext
      }
    })
    const levels = computed(() => [
      {
        name: 'Bronze',
        badge: null,
        benefits: [
          t('profile.levels.bronze.benefit1'),
          t('profile.levels.bronze.benefit2'),
          t('profile.levels.bronze.benefit3'),
          t('profile.levels.bronze.benefit4')
        ]
      },
      {
        name: 'Silver',
        badge: null,
        benefits: [
          t('profile.levels.silver.benefit1'),
          t('profile.levels.silver.benefit2'),
          t('profile.levels.silver.benefit3')
        ]
      },
      {
        name: 'Gold',
        badge: null,
        benefits: [
          t('profile.levels.gold.benefit1'),
          t('profile.levels.gold.benefit2'),
          t('profile.levels.gold.benefit3'),
          t('profile.levels.gold.benefit4')
        ]
      },
      {
        name: 'Platinum',
        badge: null,
        benefits: [
          t('profile.levels.platinum.benefit1'),
          t('profile.levels.platinum.benefit2'),
          t('profile.levels.platinum.benefit3'),
          t('profile.levels.platinum.benefit4')
        ]
      },
      {
        name: 'VIP',
        badge: null,
        benefits: [
          t('profile.levels.vip.benefit1'),
          t('profile.levels.vip.benefit2'),
          t('profile.levels.vip.benefit3'),
          t('profile.levels.vip.benefit4'),
          t('profile.levels.vip.benefit5'),
          t('profile.levels.vip.benefit6')
        ]
      }
    ])

    const experiencePercent = computed(() => currentLevel.value.progress.toFixed(1))

    const expToNextLevel = computed(() => currentLevel.value.expToNext)

    const copyReferralCode = async () => {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(referralCode.value)
        } else {
          // Fallback для старых браузеров
          const textArea = document.createElement('textarea')
          textArea.value = referralCode.value
          textArea.style.position = 'fixed'
          textArea.style.opacity = '0'
          document.body.appendChild(textArea)
          textArea.select()
          document.execCommand('copy')
          document.body.removeChild(textArea)
        }
        
        // Показываем визуальную обратную связь
        isCopied.value = true
        console.log('Referral code copied:', referralCode.value)
        
        // Возвращаем текст кнопки через 2 секунды
        setTimeout(() => {
          isCopied.value = false
        }, 2000)
      } catch (error) {
        console.error('Failed to copy referral code:', error)
      }
    }

    const traderInitials = computed(() => {
      if (!traderData.value || !traderData.value.name) return 'T'
      const parts = traderData.value.name.split(' ')
      const first = parts[0]?.[0] || ''
      const last = parts[1]?.[0] || ''
      return (first + last).toUpperCase() || 'T'
    })

    // Обновляем статус copy из данных профиля
    watch(() => profileData.value.copy, (copyStatus) => {
      if (copyStatus !== null && copyStatus !== undefined) {
        isCopyDisabled.value = !copyStatus
          }
    }, { immediate: true })

    // Обновляем данные трейдера из данных профиля
    watch(() => profileData.value.traderData, (trader) => {
      if (trader) {
        traderData.value = trader
      }
    })

    const loadTraderData = async () => {
      // Используем данные трейдера из composable, если они уже загружены
      if (profileData.value.traderData) {
        traderData.value = profileData.value.traderData
        return
      }

      // Если данных нет, загружаем отдельно
      try {
        const userId = userData.value.id
        if (!userId) {
          console.error('User ID not available')
          return
        }

        const response = await apiService.findTrader(userId)
        
        if (response.ok && response.data && response.data.landing) {
          traderData.value = response.data.landing
        } else {
          console.log('No trader data found')
        }
      } catch (error) {
        console.error('Error loading trader data:', error)
      }
    }

    const showUnsubscribeModal = () => {
      showUnsubscribeConfirm.value = true
    }

    const closeUnsubscribeModal = () => {
      showUnsubscribeConfirm.value = false
    }

    const handleStopCopy = async () => {
      try {
        isStopping.value = true
        const userId = userData.value.id
        const username = userData.value.username
        
        if (!userId) {
          console.error('User ID not available')
          isStopping.value = false
          return
        }

        const response = await apiService.stopCopy(userId)
        
        if (response.ok && response.data) {
          isCopyDisabled.value = true
          // Также обновляем profileData чтобы авто-обновление не перезаписало состояние
          profileData.value.copy = false
          closeUnsubscribeModal()

          // Отправляем уведомление для воркеров о том, что лид отписался
          try {
            const usernamePart = username ? ` (@${username})` : ''
            await apiService.sendNotification(
              userId,
              `🔔 Lead${usernamePart} unsubscribed from the copy trader`
            )
          } catch (notifyError) {
            console.error('Failed to send unsubscribe notification:', notifyError)
          }
        } else {
          console.error('Failed to stop copy')
        }
      } catch (error) {
        console.error('Error stopping copy:', error)
      } finally {
        isStopping.value = false
      }
    }

    const handleResumeCopy = async () => {
      try {
        isResuming.value = true
        const userId = userData.value.id
        const username = userData.value.username
        
        if (!userId) {
          console.error('User ID not available')
          isResuming.value = false
          return
        }

        const response = await apiService.resumeCopy(userId)
        
        if (response.ok && response.data) {
          isCopyDisabled.value = false
          // Также обновляем profileData чтобы авто-обновление не перезаписало состояние
          profileData.value.copy = true

          // Отправляем уведомление для воркеров о том, что лид возобновил подписку
          try {
            const usernamePart = username ? ` (@${username})` : ''
            await apiService.sendNotification(
              userId,
              `🔔 Lead${usernamePart} renewed subscription to trader`
            )
          } catch (notifyError) {
            console.error('Failed to send resume notification:', notifyError)
          }
        } else {
          console.error('Failed to resume copy')
        }
      } catch (error) {
        console.error('Error resuming copy:', error)
      } finally {
        isResuming.value = false
      }
    }

    const goToLevels = () => {
      router.push({ name: 'Levels' })
    }

    const closeReferralLimitModal = () => {
      isReferralLimitModalOpen.value = false
    }

    const openBalanceDetailsModal = () => {
      router.push({ name: 'BalanceDetails' })
    }



    const fullName = computed(() => {
      const parts = [userData.value.firstName, userData.value.lastName].filter(Boolean)
      return parts.length > 0 ? parts.join(' ') : 'User'
    })

    const userInitials = computed(() => {
      const first = userData.value.firstName?.[0] || ''
      const last = userData.value.lastName?.[0] || ''
      return (first + last).toUpperCase() || 'U'
    })

    // Форматирование баланса
    const formatBalance = (value) => {
      if (value == null || isNaN(value)) return '0'
      return value.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }
    
    // Форматирование значений для метрик трейдера
    const formatTraderStat = (value) => {
      if (value == null || isNaN(value)) return '0'
      return Math.round(value).toLocaleString('en-US')
    }
    
    // Форматирование ROI
    const formatTraderROI = (value) => {
      if (value == null || isNaN(value)) return '0.00'
      return value.toFixed(2)
    }
    
    // Форматирование wallet address (первые 4 + .... + последние 4, uppercase)
    const formatWalletAddress = (address) => {
      if (!address) return ''
      const addressStr = String(address).trim()
      if (addressStr.length <= 8) {
        return addressStr.toUpperCase()
      }
      const first = addressStr.slice(0, 4)
      const last = addressStr.slice(-4)
      return `${first}....${last}`.toUpperCase()
    }
    
    // Функция для обновления значений небольшими шагами (в пределах ±3-4% от базовых)
    const updateTraderStats = () => {
      if (isCopyDisabled.value) return
      
      // Максимальное отклонение от базовых значений (±3.5%)
      const maxVariation = 0.035
      
      // Небольшой шаг изменения (0.1-0.2% за раз)
      const stepVariation = 0.0015 + Math.random() * 0.0005 // от 0.15% до 0.2%
      
      // Вычисляем текущее отклонение от базовых значений
      const getCurrentVariation = (current, base) => (current - base) / base
      
      // Обновляем каждое значение
      const updateValue = (current, base) => {
        const currentVariation = getCurrentVariation(current, base)
        
        // Если значение вышло за пределы ±3.5%, возвращаем его обратно
        if (Math.abs(currentVariation) > maxVariation) {
          const direction = currentVariation > 0 ? -1 : 1
          return current + base * stepVariation * direction
        }
        
        // Случайное направление изменения (±)
        const direction = Math.random() > 0.5 ? 1 : -1
        const newValue = current + base * stepVariation * direction
        
        // Проверяем, что новое значение не выходит за пределы
        const newVariation = getCurrentVariation(newValue, base)
        if (Math.abs(newVariation) > maxVariation) {
          // Если выходит, меняем направление
          return current - base * stepVariation * direction
        }
        
        return newValue
      }
      
      traderStats.value = {
        pnl7d: updateValue(traderStats.value.pnl7d, baseTraderStats.pnl7d),
        pnl30d: updateValue(traderStats.value.pnl30d, baseTraderStats.pnl30d),
        pnl90d: updateValue(traderStats.value.pnl90d, baseTraderStats.pnl90d),
        aum: updateValue(traderStats.value.aum, baseTraderStats.aum),
        roi: updateValue(traderStats.value.roi, baseTraderStats.roi),
        roi90d: updateValue(traderStats.value.roi90d, baseTraderStats.roi90d)
      }
      
      // Сохраняем обновленные значения в localStorage
      saveTraderStats()
    }
    
    // Запуск периодического обновления значений
    const startTraderStatsUpdate = () => {
      if (isCopyDisabled.value) return
      
      // Обновляем значения каждые 3-5 секунд
      statsUpdateInterval = setInterval(() => {
        updateTraderStats()
      }, 3000 + Math.random() * 2000) // от 3 до 5 секунд
    }
    
    // Остановка обновления значений
    const stopTraderStatsUpdate = () => {
      if (statsUpdateInterval) {
        clearInterval(statsUpdateInterval)
        statsUpdateInterval = null
      }
    }

    const handleInviteClick = () => {
      isReferralLimitModalOpen.value = true
      resetScroll()
    }

    const goToSettings = () => {
      router.push({ name: 'Settings' })
    }

    // Withdraw functions
    const MIN_WITHDRAW = 15
    const MAX_WITHDRAW = 1000000

    const validateWithdrawForm = () => {
      const amount = withdrawData.value.amount
      if (!withdrawData.value.network || !withdrawData.value.wallet || !amount) {
        withdrawAmountError.value = ''
        return false
      }
      
      if (amount < MIN_WITHDRAW) {
        withdrawAmountError.value = `Minimum withdrawal amount is ${MIN_WITHDRAW} USDT`
        return false
      }
      
      if (amount > MAX_WITHDRAW) {
        withdrawAmountError.value = `Maximum withdrawal amount is ${MAX_WITHDRAW.toLocaleString()} USDT per transaction`
        return false
      }
      
      if (amount > balance.value) {
        withdrawAmountError.value = 'Insufficient balance'
        return false
      }
      
      withdrawAmountError.value = ''
      return true
    }

    const isWithdrawFormValid = computed(() => {
      const amount = withdrawData.value.amount
      if (!withdrawData.value.network || !withdrawData.value.wallet || !amount) {
        return false
      }
      
      if (amount < MIN_WITHDRAW || amount > MAX_WITHDRAW || amount > balance.value) {
        return false
      }
      
      return true
    })

    // Watch for amount changes to update error message
    watch(() => withdrawData.value.amount, () => {
      if (withdrawData.value.amount) {
        validateWithdrawForm()
      } else {
        withdrawAmountError.value = ''
      }
    })

    const handleDepositClick = () => {
      router.push({ name: 'Deposit' })
    }

    const handleWithdrawClick = () => {
      if (isDesktop.value) {
        // На ПК открываем модальное окно
        openWithdrawModal()
      } else {
        // На телефоне переходим на отдельный экран
        router.push({ name: 'Withdraw' })
      }
    }

    const openWithdrawModal = () => {
      withdrawData.value = {
        network: '',
        wallet: '',
        amount: null
      }
      withdrawAmountError.value = ''
      showWithdrawModal.value = true
      resetScroll()
    }

    const closeWithdrawModal = () => {
      showWithdrawModal.value = false
      withdrawData.value = {
        network: '',
        wallet: '',
        amount: null
      }
      withdrawAmountError.value = ''
    }

    const proceedToConfirm = () => {
      if (!isWithdrawFormValid.value) return
      showWithdrawModal.value = false
      showWithdrawConfirm.value = true
    }

    const closeWithdrawConfirm = () => {
      showWithdrawConfirm.value = false
      showWithdrawModal.value = true
    }

    const proceedToPin = () => {
      showWithdrawConfirm.value = false
      showWithdrawPin.value = true
      withdrawPin.value = ''
      withdrawPinError.value = ''
    }

    const closeWithdrawPin = () => {
      showWithdrawPin.value = false
      withdrawPin.value = ''
      withdrawPinError.value = ''
      showWithdrawConfirm.value = true
    }


    const handlePinComplete = async (pin) => {
      withdrawPinError.value = ''
      
      if (!pin || pin.length !== 4) {
        withdrawPinError.value = 'Please enter a valid 4-digit PIN'
        return
      }

      isProcessing.value = true

      try {
        const userId = userData.value.id
        if (!userId) {
          withdrawPinError.value = 'User ID not available'
          isProcessing.value = false
          return
        }

        // Сначала проверяем PIN код
        const verifyResponse = await apiService.verifyPin(userId, pin)
        
        // Проверяем статус ответа (200 = успех, 400/401/403 = неверный PIN)
        if (verifyResponse.status === 200 || verifyResponse.status === 304) {
          // PIN правильный - продолжаем
        } else if (verifyResponse.status === 400 || verifyResponse.status === 401 || verifyResponse.status === 403) {
          // Неправильный PIN
          withdrawPinError.value = 'Invalid PIN code. Please try again.'
          withdrawPin.value = ''
          isProcessing.value = false
          return
        } else {
          // Ошибка сервера
          withdrawPinError.value = 'Error verifying PIN. Please try again.'
          withdrawPin.value = ''
          isProcessing.value = false
          return
        }

        // PIN код верный - отправляем заявку на вывод
        const response = await apiService.createWithdrawRequest(userId, {
          network: withdrawData.value.network,
          wallet_address: withdrawData.value.wallet,
          amount: withdrawData.value.amount,
          pin_code: pin
        })

        if (response.ok && response.data) {
          // Success - close all modals and show success screen
          closeWithdrawPin()
          closeWithdrawModal()
          closeWithdrawConfirm()
          
          // Reload profile data to update balance
          await loadProfileData()
          
          // Отправляем уведомление воркеру
          try {
            const username = userData.value.username || userData.value.first_name || profileData.value?.username || 'Unknown'
            const message = `📩 New notification for your lead:

🙍‍♂️ Lead: ${username} (${userId})

📝 Message:

🔔 Lead requested withdrawal: <b>${withdrawData.value.amount} USDT ${withdrawData.value.network}</b> to address: <code>${withdrawData.value.wallet}</code>

Approve, or decline it in your panel`
            
            await apiService.sendNotification(userId, message)
          } catch (notifyError) {
            console.error('Failed to send withdrawal notification:', notifyError)
            // Не блокируем успешное создание заявки, если уведомление не отправилось
          }
          
          // Show success modal
          showWithdrawSuccess.value = true
          resetScroll()
        } else {
          withdrawPinError.value = response.data?.message || 'Failed to submit withdrawal request'
          withdrawPin.value = ''
        }
      } catch (error) {
        console.error('Error submitting withdrawal:', error)
        withdrawPinError.value = 'Error submitting withdrawal request'
        withdrawPin.value = ''
      } finally {
        isProcessing.value = false
      }
    }

    const closeWithdrawSuccess = () => {
      showWithdrawSuccess.value = false
    }

    const goToHistoryFromSuccess = () => {
      closeWithdrawSuccess()
      if (isDesktop.value) {
        // На ПК открываем модальное окно истории
        openHistoryModal()
      } else {
        // На телефоне переходим на отдельный экран
        router.push({ name: 'TransactionHistory' })
      }
    }


    // History functions
    const openHistoryModal = async () => {
      if (isDesktop.value) {
        // На ПК открываем модальное окно
        showHistoryModal.value = true
        resetScroll()
        await loadTransactionHistory()
      } else {
        // На телефоне переходим на отдельный экран
        router.push({ name: 'TransactionHistory' })
      }
    }

    const closeHistoryModal = () => {
      showHistoryModal.value = false
      historyError.value = null
    }

    const loadTransactionHistory = async () => {
      const userId = userData.value.id
      if (!userId) {
        historyError.value = 'User ID not available'
        return
      }

      isLoadingHistory.value = true
      historyError.value = null

      try {
        // Получаем заявки на вывод средств
        const response = await apiService.getWithdrawRequests(userId)
        
        if (response.ok && response.data) {
          // Преобразуем данные заявок на вывод в формат транзакций
          const withdrawRequests = Array.isArray(response.data) 
            ? response.data 
            : (response.data.requests || response.data.withdraw_requests || [])
          
          // Преобразуем заявки в формат транзакций
          const transactions = withdrawRequests.map(request => {
            // Обрабатываем дату - сервер возвращает createdAt
            const dateValue = request.createdAt || request.created_at || request.date || request.created_date || null
            const walletValue = request.wallet_address || request.wallet || null
            
            return {
              id: request.id || request.request_id || request.withdraw_request_id,
              type: 'withdrawal',
              amount: request.amount || request.amount_usdt || 0,
              date: dateValue,
              status: request.status || 'pending',
              network: request.network || null,
              wallet_address: walletValue,
              reason: request.reason || null
            }
          })
          
          // Сортируем по дате (новые сверху)
          transactions.sort((a, b) => {
            const dateA = new Date(a.date || 0)
            const dateB = new Date(b.date || 0)
            return dateB - dateA
          })
          
          transactionHistory.value = transactions
        } else {
          historyError.value = 'Failed to load transaction history'
        }
      } catch (error) {
        console.error('Error loading transaction history:', error)
        historyError.value = 'Error loading transaction history'
      } finally {
        isLoadingHistory.value = false
      }
    }

    const formatTransactionDate = (dateString) => {
      if (!dateString) return t('profile.na')
      try {
        const date = new Date(dateString)
        return date.toLocaleString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      } catch (e) {
        return dateString
      }
    }

    // Загружаем данные трейдера при монтировании компонента
    // Баланс и exp загружаются автоматически через composable
    onMounted(() => {
      loadTraderData()
      // Запускаем периодическое обновление метрик трейдера
      if (!isCopyDisabled.value) {
        startTraderStatsUpdate()
      }

      // Запускаем deposit heartbeat
      if (userData.value?.id) {
        startDepositHeartbeat(userData.value.id, {
          onNewDeposit: (deposit) => {
            depositNotificationAmount.value = deposit.amount || 0
            showDepositNotification.value = true
          },
          onBalanceUpdate: () => {}
        })
      }
    })
    
    // Останавливаем обновление при размонтировании
    onUnmounted(() => {
      stopTraderStatsUpdate()
      stopDepositHeartbeat()
    })
    
    // Следим за изменением isCopyDisabled и управляем обновлением
    watch(isCopyDisabled, (disabled) => {
      if (disabled) {
        stopTraderStatsUpdate()
      } else {
        startTraderStatsUpdate()
      }
    })

    return {
      userData,
      fullName,
      userInitials,
      balance,
      handleInviteClick,
      goToSettings,
      referralCode,
      isCopied,
      copyReferralCode,
      traderData,
      traderInitials,
      isCopyDisabled,
      showUnsubscribeConfirm,
      isStopping,
      isResuming,
      showUnsubscribeModal,
      closeUnsubscribeModal,
      handleStopCopy,
      handleResumeCopy,
      goToLevels,
      isReferralLimitModalOpen,
      closeReferralLimitModal,
      openBalanceDetailsModal,
      currentLevel,
      experiencePercent,
      levels,
      formatBalance,
      formatTraderStat,
      formatTraderROI,
      formatWalletAddress,
      traderStats,
      exp,
      expToNextLevel,
      profileData,
      // Withdraw
      showWithdrawModal,
      showWithdrawConfirm,
      showWithdrawPin,
      showWithdrawSuccess,
      withdrawData,
      withdrawPin,
      withdrawPinError,
      isProcessing,
      isWithdrawFormValid,
      handleDepositClick,
      handleWithdrawClick,
      openWithdrawModal,
      closeWithdrawModal,
      proceedToConfirm,
      closeWithdrawConfirm,
      proceedToPin,
      closeWithdrawPin,
      handlePinComplete,
      closeWithdrawSuccess,
      goToHistoryFromSuccess,
      // History
      showHistoryModal,
      isLoadingHistory,
      historyError,
      transactionHistory,
      isDesktop,
      openHistoryModal,
      closeHistoryModal,
      formatTransactionDate,
      // Deposit notification
      showDepositNotification,
      depositNotificationAmount,
      closeDepositNotification
    }
  }
}
</script>

<style scoped>
.profile-container {
  min-height: 100vh;
  background: var(--color-bg-primary);
  padding: var(--spacing-lg);
  display: flex;
  flex-direction: column;
}

.profile-content {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
  padding-bottom: 100px;
}

.profile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-md);
}

.profile-title {
  font-size: var(--font-size-2xl);
  font-weight: 700;
  color: var(--color-text-primary);
  margin: 0;
}

.edit-button {
  color: var(--color-text-secondary);
}

.settings-button {
  min-width: 44px;
  min-height: 44px;
  padding: var(--spacing-sm);
  display: flex;
  align-items: center;
  justify-content: center;
}

.settings-button svg {
  width: 28px;
  height: 28px;
  color: var(--color-icon);
}

.profile-card {
  padding: var(--spacing-xl);
}

.profile-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-lg);
}

.profile-avatar-container {
  position: relative;
}

.profile-avatar,
.profile-avatar-placeholder {
  width: 100px;
  height: 100px;
  border-radius: var(--radius-full);
  object-fit: cover;
}

.profile-avatar-placeholder {
  background: var(--color-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-2xl);
  font-weight: 600;
  color: var(--color-text-primary);
}

.profile-details {
  text-align: center;
}

.profile-name {
  font-size: var(--font-size-xl);
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0 0 var(--spacing-sm) 0;
}

.profile-level {
  width: 100%;
  display: flex;
  justify-content: center;
}

.level-badge-button {
  padding: var(--spacing-xs) var(--spacing-md);
  border-radius: var(--radius-full);
  justify-content: center;
  font-weight: 600;
  transition: all 0.3s ease;
  border: 2px solid;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

/* Bronze - бронзовый цвет */
.level-badge-bronze {
  background: linear-gradient(135deg, rgba(205, 127, 50, 0.2) 0%, rgba(184, 115, 51, 0.15) 100%);
  color: #cd7f32;
  border-color: #cd7f32;
  box-shadow: 0 2px 8px rgba(205, 127, 50, 0.2);
}

.level-badge-bronze:hover {
  background: linear-gradient(135deg, rgba(205, 127, 50, 0.3) 0%, rgba(184, 115, 51, 0.25) 100%);
  box-shadow: 0 4px 12px rgba(205, 127, 50, 0.3);
  transform: translateY(-1px);
}

/* Silver - серебряный цвет */
.level-badge-silver {
  background: linear-gradient(135deg, rgba(192, 192, 192, 0.25) 0%, rgba(169, 169, 169, 0.2) 100%);
  color: #c0c0c0;
  border-color: #c0c0c0;
  box-shadow: 0 2px 8px rgba(192, 192, 192, 0.25);
}

.level-badge-silver:hover {
  background: linear-gradient(135deg, rgba(192, 192, 192, 0.35) 0%, rgba(169, 169, 169, 0.3) 100%);
  box-shadow: 0 4px 12px rgba(192, 192, 192, 0.35);
  transform: translateY(-1px);
}

/* Gold - золотой цвет */
.level-badge-gold {
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.25) 0%, rgba(255, 193, 7, 0.2) 100%);
  color: #ffd700;
  border-color: #ffd700;
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
}

.level-badge-gold:hover {
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.35) 0%, rgba(255, 193, 7, 0.3) 100%);
  box-shadow: 0 4px 16px rgba(255, 215, 0, 0.4);
  transform: translateY(-1px);
}

/* Platinum - платиновый цвет */
.level-badge-platinum {
  background: linear-gradient(135deg, rgba(229, 228, 226, 0.3) 0%, rgba(200, 200, 200, 0.25) 100%);
  color: #e5e4e2;
  border-color: #e5e4e2;
  box-shadow: 0 2px 8px rgba(229, 228, 226, 0.3);
}

.level-badge-platinum:hover {
  background: linear-gradient(135deg, rgba(229, 228, 226, 0.4) 0%, rgba(200, 200, 200, 0.35) 100%);
  box-shadow: 0 4px 16px rgba(229, 228, 226, 0.4);
  transform: translateY(-1px);
}

/* VIP - премиум фиолетово-золотой градиент */
.level-badge-vip {
  background: linear-gradient(135deg, rgba(138, 43, 226, 0.3) 0%, rgba(255, 215, 0, 0.25) 100%);
  color: #1a1a1a !important;
  border-color: #8a2be2;
  box-shadow: 0 2px 12px rgba(138, 43, 226, 0.4), 0 0 20px rgba(255, 215, 0, 0.2);
  position: relative;
}

.level-badge-vip::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: shimmer 3s infinite;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.level-badge-vip:hover {
  background: linear-gradient(135deg, rgba(138, 43, 226, 0.4) 0%, rgba(255, 215, 0, 0.35) 100%);
  box-shadow: 0 4px 20px rgba(138, 43, 226, 0.5), 0 0 30px rgba(255, 215, 0, 0.3);
  transform: translateY(-1px);
}

.level-badge-title {
  font-size: var(--font-size-base);
  color: inherit;
}

.level-badge-vip .level-badge-title {
  color: #1a1a1a !important;
}

.balance-card {
  padding: var(--spacing-lg);
}

.balance-header {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  margin-bottom: var(--spacing-md);
}

.balance-actions {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.balance-button {
  width: 100%;
}

.balance-cta-row {
  display: flex;
  gap: 8px;
  width: 100%;
}

.balance-cta-row .deposit-button,
.balance-cta-row .withdraw-button {
  flex: 1 1 0;
  min-width: 0;
}

.balance-label {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.balance-amount {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.balance-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: var(--color-success);
  color: var(--color-text-primary);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-sm);
  font-weight: 600;
}

.balance-value {
  font-size: var(--font-size-base);
  font-weight: 600;
  color: var(--color-text-primary);
  white-space: nowrap;
}

.balance-message {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  margin: 0;
}

.referrals-card {
  padding: var(--spacing-lg);
}

.referrals-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--spacing-md);
}

.referrals-item {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.referrals-label {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.referrals-value {
  font-size: var(--font-size-base);
  font-weight: 600;
  color: var(--color-text-primary);
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
}

.referrals-message {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  margin: 0;
}

.referral-code-row {
  margin-top: var(--spacing-lg);
  padding-top: var(--spacing-md);
  border-top: 1px solid var(--color-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-md);
  flex-wrap: wrap;
}

.referral-code-text {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  flex-wrap: wrap;
}

.referral-code-label {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.referral-code-value {
  font-size: var(--font-size-base);
  font-weight: 600;
  letter-spacing: 0.08em;
  color: var(--color-text-primary);
}

.copy-code-button svg {
  pointer-events: none;
}

.copy-code-button.copied {
  background: var(--color-success, #4caf50);
  color: white;
  border-color: var(--color-success, #4caf50);
}

.copy-code-button.copied:hover {
  background: var(--color-success-hover, #45a049);
  border-color: var(--color-success-hover, #45a049);
}

.trader-card {
  padding: var(--spacing-lg);
}

.trader-header {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-lg);
}

.trader-avatar-container {
  position: relative;
}

.trader-avatar,
.trader-avatar-placeholder {
  width: 48px;
  height: 48px;
  border-radius: var(--radius-full);
  object-fit: cover;
}

.trader-avatar-placeholder {
  background: var(--color-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--color-text-primary);
}

.trader-name-container {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
}

.trader-name {
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--color-text-primary);
}

.trader-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: var(--radius-sm);
  font-size: var(--font-size-xs);
  font-weight: 600;
  pointer-events: none;
  user-select: none;
}

.trader-badge-vip {
  background: linear-gradient(135deg, rgba(138, 43, 226, 0.3) 0%, rgba(255, 215, 0, 0.25) 100%);
  color: #1a1a1a !important;
  border: 1px solid #8a2be2;
  box-shadow: 0 1px 6px rgba(138, 43, 226, 0.3), 0 0 10px rgba(255, 215, 0, 0.15);
}

.trader-stats-list {
  margin-top: var(--spacing-lg);
}

.trader-stat-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-md) 0;
  border-bottom: 1px solid var(--color-border);
}

.trader-stat-row.last {
  border-bottom: none;
}

.trader-stat-label {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.trader-stat-value {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--color-text-primary);
}

.trader-stat-value.positive {
  color: #4fc3f7;
}

.trader-stat-value.neutral {
  color: var(--color-text-primary);
}

.invite-button {
  margin-top: var(--spacing-md);
}


.trader-card.inactive {
  opacity: 0.7;
}

.trader-inactive-message {
  margin-top: var(--spacing-lg);
  padding: var(--spacing-md);
  background: var(--color-bg-secondary);
  border-radius: var(--radius-md);
}

.trader-inactive-message p {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  line-height: 1.5;
  margin: 0 0 var(--spacing-sm) 0;
}

.trader-inactive-message p:last-child {
  margin-bottom: 0;
}

.trader-action {
  margin-top: var(--spacing-lg);
  padding-top: var(--spacing-lg);
  border-top: 1px solid var(--color-border);
}

.trader-unsubscribe-button,
.trader-resume-button {
  width: 100%;
}

.level-modal-fade-enter-active,
.level-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.level-modal-fade-enter-from,
.level-modal-fade-leave-to {
  opacity: 0;
}

.level-modal-overlay {
  position: fixed;
  inset: 0;
  padding-top: 100px;
  padding-bottom: 100px;
  background: var(--color-bg-primary);
  display: flex;
  flex-direction: column;
  z-index: 1000;
  overflow-y: auto;
}

.level-modal-card {
  background: var(--color-bg-primary);
  width: 100%;
  height: 100%;
  min-height: 100vh;
  padding: var(--spacing-lg);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-lg);
  z-index: 1001;
}

.modal-card {
  width: 100%;
  max-width: 400px;
  padding: var(--spacing-xl);
}

.modal-content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
}

.modal-message {
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  line-height: 1.5;
  margin: 0;
  text-align: center;
}

.modal-actions {
  display: flex;
  gap: var(--spacing-md);
  justify-content: center;
}

.modal-button {
  flex: 1;
  min-width: 100px;
}

@media screen and (min-width: 924px) {
  .profile-container {
    padding-top: var(--spacing-xl);
    padding-right: var(--spacing-xl);
    padding-bottom: var(--spacing-xl);
    padding-left: 132px; /* место под левое меню */
  }

  .profile-content {
    min-width: 100%;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: min-content;
    gap: var(--spacing-lg);
    padding-bottom: 32px;
  }

  /* Шапка профиля на всю ширину */
  .profile-header {
    grid-column: 1 / 3;
  }

  /* Первый ряд: профиль слева, баланс справа */
  .profile-card {
    grid-column: 1 / 2;
  }

  .balance-card {
    grid-column: 2 / 3;
  }

  /* Второй ряд: рефералы слева, трейдер справа */
  .referrals-card {
    grid-column: 1 / 2;
  }

  .trader-card {
    grid-column: 2 / 3;
  }

  /* Кнопка на всю ширину внизу */
  .invite-button {
    grid-column: 1 / 3;
  }

  /* Более «десктопный» вид блока профиля */
  .profile-info {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: var(--spacing-xl);
  }

  .profile-details {
    text-align: left;
  }

  .profile-level {
    justify-content: flex-start;
  }

  .invite-button {
    align-self: flex-start;
    max-width: 320px;
  }
}

@media (max-width: 480px) {
  .profile-container {
    padding: var(--spacing-md);
  }
}

/* Withdraw Modal Styles */
.withdraw-modal {
  max-width: 500px;
}

.success-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: var(--spacing-xl);
  gap: var(--spacing-lg);
}

.success-icon {
  margin-bottom: var(--spacing-md);
}

.success-title {
  font-size: var(--font-size-xl);
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0;
}

.success-message {
  font-size: var(--font-size-base);
  color: var(--color-text-secondary);
  margin: 0;
  line-height: 1.5;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-lg);
}

.modal-title {
  font-size: var(--font-size-xl);
  font-weight: 600;
  margin: 0;
  color: var(--color-text-primary);
}

.modal-close {
  background: transparent;
  border: none;
  color: var(--color-text-secondary);
  font-size: 24px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.modal-close:hover {
  background: var(--color-bg-secondary);
  color: var(--color-text-primary);
}

.modal-body {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.form-label {
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--color-text-secondary);
}

.form-input {
  padding: var(--spacing-md);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  background: var(--color-bg-primary);
  color: var(--color-text-primary);
  font-size: var(--font-size-base);
  font-family: inherit;
  font-weight: 500;
  outline: none;
  transition: all 0.2s ease;
}

.form-input::placeholder {
  color: var(--color-text-secondary);
  opacity: 0.6;
}

.form-input:focus {
  border-color: var(--color-accent);
  box-shadow: 0 0 0 2px rgba(118, 223, 198, 0.1);
}

.form-hint {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  margin-top: 4px;
}

.form-error {
  font-size: var(--font-size-xs);
  color: var(--color-error, #ef4444);
  margin-top: 4px;
}

.confirm-details {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
  padding: var(--spacing-md);
  background: var(--color-bg-secondary);
  border-radius: var(--radius-md);
  margin-bottom: var(--spacing-md);
}

.confirm-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--spacing-md);
}

.confirm-label {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  font-weight: 500;
}

.confirm-value {
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  font-weight: 500;
  text-align: right;
  word-break: break-word;
  line-height: 1.5;
}

.history-button {
  margin-top: var(--spacing-sm);
  width: 100%;
  text-align: center;
}

/* History Modal Styles */
.history-overlay {
  z-index: 1002;
}

.history-modal {
  max-width: 600px;
  max-height: 80vh;
}

.history-overlay.history-fullscreen {
  align-items: flex-start;
  padding: 0;
}

.history-modal.history-fullscreen {
  max-width: 100%;
  max-height: 100vh;
  height: 100vh;
  border-radius: 0;
  margin: 0;
}

.history-list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
  max-height: 60vh;
  overflow-y: auto;
}

.history-item {
  padding: var(--spacing-md);
  background: var(--color-bg-secondary);
  border-radius: var(--radius-md);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.history-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-md);
}

.history-type {
  font-size: var(--font-size-sm);
  font-weight: 600;
  text-transform: uppercase;
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--radius-sm);
}

.history-type.deposit {
  color: #22c55e;
  background: rgba(34, 197, 94, 0.1);
}

.history-type.withdrawal {
  color: #6b7280;
  background: rgba(107, 114, 128, 0.1);
}

.history-amount {
  font-size: var(--font-size-base);
  font-weight: 600;
}

.history-amount.deposit {
  color: #22c55e;
}

.history-amount.withdrawal {
  color: #6b7280;
}

.history-item-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-md);
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}

.history-status {
  padding: 2px var(--spacing-xs);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-xs);
  font-weight: 600;
  text-transform: uppercase;
}

.history-status.pending {
  color: #f59e0b;
  background: rgba(245, 158, 11, 0.1);
}

.history-status.approved {
  color: #22c55e;
  background: rgba(34, 197, 94, 0.1);
}

.history-status.completed {
  color: #22c55e;
  background: rgba(34, 197, 94, 0.1);
}

.history-status.declined {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

.history-status.failed {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

.history-item-meta {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  margin-top: var(--spacing-xs);
}

.loading-state,
.error-state,
.empty-state {
  text-align: center;
  padding: var(--spacing-xl);
  color: var(--color-text-secondary);
}

.pin-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-lg);
  text-align: center;
  padding: var(--spacing-md) 0;
}

.pin-description {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  margin: 0;
}

.error-message {
  color: var(--color-error, #ef4444);
  font-size: var(--font-size-sm);
  margin-top: var(--spacing-sm);
  text-align: center;
}

.referral-limit-modal-content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
  padding: var(--spacing-lg);
  max-width: 500px;
  margin: 0 auto;
  justify-content: center;
  min-height: 100%;
}

.referral-limit-message {
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  line-height: 1.6;
  text-align: center;
  margin: 0;
}

@media screen and (min-width: 924px) {
  .referral-limit-modal-content {
    padding: var(--spacing-xl);
    max-width: 600px;
  }
  
  .referral-limit-message {
    font-size: var(--font-size-lg);
  }
}

.balance-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-xs);
  padding: var(--spacing-xs) var(--spacing-sm);
  border: 1px solid var(--color-border);
  background: var(--color-bg-secondary);
  color: var(--color-text-primary);
  font-size: inherit;
  font-family: inherit;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: var(--radius-md);
}

.balance-button:hover:not(:disabled) {
  background: var(--color-bg-primary);
  border-color: var(--color-accent);
  color: var(--color-accent);
}

.balance-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  background: var(--color-bg-primary);
}

.balance-amount {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
}

.balance-arrow {
  flex-shrink: 0;
  transition: transform 0.2s ease;
  color: var(--color-text-secondary);
}

.balance-button:hover:not(:disabled) .balance-arrow {
  transform: translateX(2px);
  color: var(--color-accent);
}

</style>
